import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../src/styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import arrowright from "../../assets/arrowright.svg";
import ShimmerLoader from "../../loading";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";


const CustomerCreditOrderTable = ({ additionalData, pagination, onRowClick }) => {
    const { t, i18n } = useTranslation();
    const [flag, setflag] = useState(false);
    const navigate = useNavigate();

    const allStores = useSelector(
        (state) => state?.storeReducer?.selectedStore?.is_select_all_store
    )


    // const openOrderList = (id) => {
    //     navigate(`/vendorDetails?id=${id}`);
    // };

    console.log("additionalData in table", additionalData);


    const data = useMemo(
        () =>
            additionalData || [],
        [additionalData]
    );

    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setflag(true);
            }, 3000);

            return () => clearTimeout(timer);
        }

    }, [additionalData, flag]);

    const columns = useMemo(
        () => [
            {
                Header: (
                    <div className="text-start justify-start" title={t("Session")}>
                        {t("Session")}
                    </div>
                ),
                width: "7%",
                accessor: "session",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.session}</div>
                ),
            },

            {
                Header: (
                    <div className="text-start" title={t("Receipt Number")}>
                        {t("Receipt No.")}
                    </div>
                ),
                width: "10%",
                accessor: "receipt_no",
                Cell: ({ row }) => (
                    <div className="text-start">{`${row.original.receipt_no}`}</div>
                ),
            },

            {
                Header: (
                    <div className="text-start justify-start" title={t("Date & Time")}>
                        {t("Date & Time")}
                    </div>
                ),
                width: "10%",
                accessor: "date_time",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.date_time}</div>
                ),
            },

            {
                Header: (
                    <div className="text-start" title={t("Customer")}>
                        {t("Customer")}
                    </div>
                ),
                width: "10%",
                accessor: "customer",
                Cell: ({ row }) => (
                    <div className="text-start">{`${row.original.customer ? row.original.customer : '--'}`}</div>
                    // <div className="text-start">{`${row.original.customer ? row.original.customer : '--'} ${row.original.customer_phone ? `(${row.original.customer_phone})` : '-'}`}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("No. of Items")}>
                        {t("No. of Items")}
                    </div>
                ),
                width: "6%",
                accessor: "items",
                Cell: ({ row }) => (
                    <div className="text-start">{t(row.original.items)}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("Total Credit")}>
                        {t("Total Credit")}
                    </div>
                ),
                width: "6%",
                accessor: "total_credit",
                Cell: ({ row }) => (
                    <div className="text-start">{`EGP ${row.original.total_credit}`}</div>
                ),
            },

            ...(allStores
                ? [
                    {
                        Header: (
                            <div className="text-start" title={t("Store Name")}>
                                {t("Store Name")}
                            </div>
                        ),
                        width: "10%",
                        accessor: "store_name",
                        Cell: ({ row }) => (
                            <div className="text-start">{`${row.original.store_name ? row.original.store_name : '--'}`}</div>
                        ),
                    },
                ]
                : []),


            {
                id: "action",
                Header: "",
                headerClassName: "text-start",
                // width: 50,
                width: "4%", // Add this line
                accessor: (row) =>
                    `${row.original},`,
                Cell: ({ row }) => (
                    <>
                        <button
                            className=" text-[#1b4497] rounded-lg"
                        // onClick={() => openOrderList(row.original.order_details.order_no)}
                        >
                            <img
                                src={arrowright}
                                alt="arrowright"
                                className={`${i18n.language == "en" ? "" : " rotate-180"}`}
                                height={3}
                                width={20}
                            />
                        </button>
                        {/* )
                                  } */}
                    </>
                ),
            },

            // {
            //     id: "action",
            //     Header: "",
            //     headerClassName: "text-start",
            //     // width: 50,
            //     width: "4%", // Add this line
            //     accessor: (row) =>
            //         `${row.original},`,
            //     Cell: ({ row }) => (
            //         <>
            //             <button
            //                 className=" text-[#1b4497] rounded-lg"
            //             // onClick={() => openOrderList(row.original.order_details.order_no)}
            //             >
            //                 <img
            //                     src={arrowright}
            //                     alt="arrowright"
            //                     className={`${i18n.language == "en" ? "" : " rotate-180"}`}
            //                     height={3}
            //                     width={20}
            //                 />
            //             </button>
            //             {/* )
            //           } */}
            //         </>
            //     ),
            // },

        ],
        [t]
    );

    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: 10 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    const [pageIndex, setpageIndex] = useState(1);

    useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
        };

        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex]);



    const handlePageSizeChange = (newPageSize) => {
        // Ensure the current page doesn't exceed the total available pages
        const maxPageIndex = Math.ceil(data.length / newPageSize);
        if (pageIndex > maxPageIndex) {
            setpageIndex(maxPageIndex); // Adjust the pageIndex to the last available page
        }

        setPageSize(newPageSize);
    };


    return (
        <>
            <div
                className="container flex flex-col mx-auto mt-4"
                style={{ maxWidth: "100%" }}
            >
                {additionalData?.length == 0 && flag == false ? (
                    <div className="h-screen w-[90%] mt-2 ">
                        <ShimmerLoader />
                    </div>
                ) : (
                    <>
                        {/* Header Table (Fixed) */}
                        <div>
                            <table
                                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                                style={{ tableLayout: "fixed" }}
                            >
                                <thead>
                                    {headerGroups.map((headerGroup, headerIndex) => {
                                        const { key: headerKey, ...headerGroupProps } =
                                            headerGroup.getHeaderGroupProps();
                                        return (
                                            <tr
                                                key={headerKey}
                                                {...headerGroupProps}
                                                className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                                            >
                                                {headerGroup.headers.map((column, colIndex) => {
                                                    const { key: columnKey, ...columnProps } =
                                                        column.getHeaderProps(
                                                            column.getSortByToggleProps()
                                                        );
                                                    return (
                                                        <th
                                                            key={columnKey}
                                                            {...columnProps}
                                                            className="py-3 whitespace-nowrap"
                                                            style={{ width: column.width }} // Set column width
                                                        >
                                                            <div className="flex items-start ms-2 text-[13px] ">
                                                                {column.render("Header")}
                                                                <span className="">
                                                                    {column.isSorted ? (
                                                                        column.isSortedDesc ? (
                                                                            <img
                                                                                src={Vectorsorting}
                                                                                style={{ minHeight: 10, minWidth: 10 }}
                                                                                alt="vector"
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                className="rotate-180"
                                                                                src={Vectorsorting}
                                                                                alt="vector"
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </thead>
                            </table>
                        </div>

                        {/* Body Table (Scrollable) */}
                        <div
                            className="scrollbar-none bg-white"
                            style={{
                                overflowY: "auto",
                                maxHeight: "600px", // Adjust height as needed
                            }}
                        >
                            <table
                                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                                style={{ tableLayout: "fixed" }}
                            >
                                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                                    {page.map((row) => {
                                        prepareRow(row);
                                        return (
                                            <React.Fragment key={row.id}>
                                                <tr
                                                    {...row.getRowProps()}
                                                    className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                                    onClick={() => onRowClick && onRowClick(row.original)}
                                                //   onClick={() => openOrderList(row.original.id)}
                                                >
                                                    {row.cells.map((cell, index) => (
                                                        <td
                                                            key={index}
                                                            {...cell.getCellProps()}
                                                            className={`p-2 text-[#272728] h-1212 text-[13px] font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                                                } ${cell?.column?.Header == "Product"
                                                                    ? "cursor-pointer"
                                                                    : ""
                                                                }`}
                                                            style={{ width: cell.column.width }} // Match column width
                                                        >
                                                            {cell.render("Cell")}
                                                        </td>
                                                    ))}
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                    {page.length === 0 && (
                                        <tr>
                                            <td colSpan={"100%"}>
                                                <Empty
                                                    className="mt-10"
                                                    description={t("No data available")}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination */}
                        <div className="">
                            <CustomPagination
                                data={data?.length}
                                pageIndex={pageIndex}
                                pageCount={page?.length}
                                canPreviousPage={pageIndex != 1 ? true : false}
                                canNextPage={data?.length == pageSize ? true : false}
                                gotoPage={(page) => {
                                    nextPage(page);
                                }}
                                previousPage={() => {
                                    setpageIndex(pageIndex - 1);
                                }}
                                nextPage={() => {
                                    setpageIndex(pageIndex + 1);
                                }}
                                pageSize={pageSize}
                                setPageSize={handlePageSizeChange}

                            // setPageSize={(pageSize) => {
                            //     setPageSize(pageSize);
                            // }}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default CustomerCreditOrderTable;
